<template>
  <SubscriptionForm
    v-if="showEdit"
    :subscription="_subscription"
    :showEdit="showEdit"
    @close="showEdit = false"
  />
  <ExtendForm
    v-if="showExtend"
    :subscription="_subscription"
    :showExtend="showExtend"
    @close="showExtend = false"
  />
  <div class="flex flex-col rounded-[8px] bg-white ring-1 ring-gray-light">
    <div
      class="flex items-center justify-between border-b border-solid border-gray-light px-4 py-3"
    >
      <div class="flex items-center gap-2">
        <IconHouse v-if="isApartment" />
        <IconCar v-if="isParking" />
        <IconStorage v-if="isPremise" />
        <p class="text-t5">
          {{ typeOfSubscription }}
        </p>
      </div>
      <div>
        <p v-if="expiring" class="text-b2">Går ut snart</p>
        <p v-else class="text-b2">Gäller till</p>
        <p :class="{ 'text-danger': expiring }" class="text-t6 font-thick">
          {{ extendDate }}
        </p>
      </div>
    </div>
    <div class="flex flex-1 flex-col gap-2 border-b border-solid border-gray-light px-4 py-4">
      <p class="text-b2">Sökkriterier</p>
      <div class="flex flex-wrap gap-2">
        <div
          v-for="criteria in searchCriteria"
          :key="searchCriteria"
          class="text-b1 rounded-[4px] bg-gray-10 px-4 py-1 ring-1 ring-gray-light"
        >
          {{ criteria }}
        </div>
        <div
          v-if="!expiring"
          v-for="criteria in oldCriteria"
          class="text-b1 rounded-[4px] bg-gray-10 px-4 py-1 ring-1 ring-gray-light"
        >
          {{ criteria }}
        </div>
      </div>



        <div v-if="oldCriteria && oldCriteria.length > 0 && !!expiring">
          <div class="mt-2 mb-2">Din bevakning innehåller filter för områden som inte längre finns som filtreringsval. Vänligen gör om din bevakning nedan.</div>
            <div class="flex flex-1 gap-2">
              <div
                  v-for="criteria in oldCriteria"
                  class="text-b1 rounded-[4px] bg-gray-10 px-4 py-1 ring-1 ring-gray-light line-through"
                >
                  {{ criteria }}
            </div>
          </div>
        </div>
    </div>
    <div class="flex justify-end gap-2 px-4 py-4">

      <Button variant="tertiary" size="large" v-if="expiring && !hasToMakeNew" @click="subscriptionItem = item; showExtend=true">Förläng</Button>
      <Button variant="tertiary" size="large" v-if="expiring && hasToMakeNew" @click="showEdit = true;">Gör om</Button>
      <Button v-if="!expiring" variant="tertiary" size="large" @click="showEdit = true">Ändra</Button>
      <Button
        variant="secondary"
        size="large"
        :href="`${webapp_config.url_to_search}/#/bevakning/${urlFriendlyTypeOfSubscription}/${code}`"
      >
        Gå till resultat
        <template #icon-after>
          <IconArrowRight />
        </template>
      </Button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Button from '@/components/ui/button';
import IconArrowRight from '@/components/icons/IconArrowRight';
import IconHouse from '@/components/icons/IconHouse';
import IconCar from '@/components/icons/IconCar';
import IconStorage from '@/components/icons/IconStorage';
import SubscriptionForm from '@/pages/subscriptions/subscription-form';
import SubscriptionMixin from '@/mixins/subscription';
import ExtendForm from '@/pages/subscriptions/extend-form';
import dayjs from 'dayjs';

export default {
  name: 'SubscriptionsItem',
  mixins: [SubscriptionMixin],
  components: {
    Button,
    IconHouse,
    IconCar,
    IconStorage,
    IconArrowRight,
    SubscriptionForm,
    ExtendForm
  },
  props: {
    subscription: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showEdit: false,
      showExtend: false
    };
  },
  methods: {


  },
  computed: {
    _subscription() {
      return { ...this.subscription };
    },
    ...mapGetters({
      webapp_config: 'webapp_config',
    })
  },
};
</script>
